import { VideoTranslations } from "./types";

export const deTranslations: VideoTranslations = {
    video: {
        title: "Sehen Sie unser Einführungsvideo",
        alt: "Unsere Vision"
    }
};